/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  // Custom mobile menu code --- Begin
  document.addEventListener("DOMContentLoaded", () => {

    // Find the mobile menu drawer element
    const mobileMenu = document.querySelector("[data-section-type='mobile-menu']");
    if (!mobileMenu) {
      return;
    }

    // Listen for link clicks inside the menu
    mobileMenu.addEventListener("click", (event) => {
      const link = event.target.closest("a");
      if (!link) return;


      // Only apply on mobile view
      if (window.innerWidth >= 768) {
        return;
      }

      // Close menu by removing the open class
      if (mobileMenu.classList.contains("is-open")) {
        mobileMenu.classList.remove("is-open");
      } else {
      }

      // Remove global drawer open class from body
      document.body.classList.remove("js-drawer-open", "js-drawer-open-cart");

      // Dispatch the scroll unlock event
      document.dispatchEvent(
        new CustomEvent("theme:scroll:unlock", {
          bubbles: true,
          detail: { delay: 0 },
        })
      );

      // Dispatch drawer close for theme components listening
      document.dispatchEvent(new CustomEvent("theme:drawer:close", { bubbles: true }));
    });
  });
  // Custom mobile menu code --- End

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
